import { Navigate } from "react-router-dom";
import { useSub } from "../../common/subscription/useSub";
import { urls } from "../../urls";
import { Home } from "./Home";

export const HomeRoute = () => {
  const sub = useSub();

  if (sub.hasSourcingEventV2Access) {
    return <Navigate to={urls.v2.home} replace />;
  }

  return <Home />;
};
